// angular import
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
// services import
import { AccountService } from './../../service/accountService.service';
import { Locale } from './../../service/locale.service';
import { ServerMapping } from './../../service/serverMapping.service';
// manager import
import { ModelsManager } from '../../manager/models.manager';
// models import
import { StockRequest } from './../../model/stock/stock_request.model';
import { StockResponse } from './../../model/stock/stock_response.model';
import { GrowlManager } from '../../manager/growl.manager';
import { DownloadManager } from '../../manager/download.manager';

@Injectable()
export class StockService {

  private searching = false;
  private stocks = [];

  constructor(private accountService:   AccountService,
    private serverMapping:              ServerMapping,
    private growlManager:               GrowlManager,
    private downloadManager:            DownloadManager,
    private locale:                     Locale,
    private http:                       Http,
    private modelManager:               ModelsManager) {}

  isSeraching() { return this.searching; }

  getStocks() { return this.stocks; }

  searchStocks() {
    if (this.searching === false) {
      this.searching = true;
    }

    this.http.get(this.serverMapping.stockSearchURL +
      '?company_code=' + this.modelManager.stock_request.company_code +
      '&supplier_code=' + this.modelManager.stock_request.supplier_code +
      '&language=' + this.modelManager.stock_request.language +
      '&type=' + this.modelManager.stock_request.type).subscribe(
        (response) => {
          const data = response.json();
          if (this.growlManager.checkForErrorInResponse(data)) {
            this.growlManager.showMessagesByResponse(data);
          }else {
            this.stocks = data.contained_bean;
          }

          this.searching = false;
        },
        (error) => {
          console.log('--------------------------------');
          console.log('!!!An error has been occurred!!!');
          console.log(error);
          console.log('--------------------------------');
        }
      );
  }

  // method wich export stock table in excel
  exportExcel(company_code, supplier_code, language, type) {
    this.http.get(this.serverMapping.stockExportExcelURL +
      '?company_code=' + company_code +
      '&supplier_code=' + supplier_code +
      '&language=' + language +
      '&type=' + type).subscribe(
        (response) => {
          const data = response.json();
          if (this.growlManager.checkForErrorInResponse(data)) {
            this.growlManager.showMessagesByResponse(data);
          }else if (data.download) {
            this.downloadManager.prepareDownload(data.download.data, data.download.file_name, data.download.mime_type);
          }
      },
      (error) => {
        console.log('--------------------------------');
        console.log('!!!An error has been occurred!!!');
        console.log(error);
        console.log('--------------------------------');
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/stock/stock.service.ts